import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@openedx/paragon';

import SectionSubHeader from '../../generic/section-sub-header';

const WhatsIncludedSection = ({
  includedVideos,
  includedAssessments,
  includedLessons,
  onChange,
}) => (
  <section className="section-container whats-included-section">
    <SectionSubHeader
      title="What's Included"
      description="Counts of included content types for this course."
    />
    <Form.Group className="form-group-custom">
      <Form.Label>Instruction Videos</Form.Label>
      <Form.Control
        type="number"
        min={0}
        value={includedVideos}
        onChange={(e) => onChange(e.target.value, 'includedVideos')}
      />
    </Form.Group>
    <Form.Group className="form-group-custom">
      <Form.Label>Assessments &amp; Quizzes</Form.Label>
      <Form.Control
        type="number"
        min={0}
        value={includedAssessments}
        onChange={(e) => onChange(e.target.value, 'includedAssessments')}
      />
    </Form.Group>
    <Form.Group className="form-group-custom">
      <Form.Label>Individual Lessons</Form.Label>
      <Form.Control
        type="number"
        min={0}
        value={includedLessons}
        onChange={(e) => onChange(e.target.value, 'includedLessons')}
      />
    </Form.Group>
  </section>
);

WhatsIncludedSection.defaultProps = {
  includedVideos: '',
  includedAssessments: '',
  includedLessons: '',
};

WhatsIncludedSection.propTypes = {
  includedVideos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  includedAssessments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  includedLessons: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};

export default WhatsIncludedSection;
